package com.klantenstop.web.styles

import com.materialkobweb.components.widgets.BorderRadius
import com.materialkobweb.styles.MaterialColorVars
import com.materialkobweb.styles.shifted
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.navigation.LinkVars
import com.varabyte.kobweb.silk.style.addVariant
import org.jetbrains.compose.web.css.px

val ErrorTextButtonStyle = ButtonStyle.addVariant {
    base {
        Modifier
            .borderRadius(ButtonVars.BorderRadius.value())
            .setVariable(ButtonVars.BorderRadius, 999.px)
            .setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
            .setVariable(ButtonVars.Color, MaterialColorVars.Error.value())
            .setVariable(LinkVars.DefaultColor, MaterialColorVars.Error.value())
            .setVariable(LinkVars.VisitedColor, MaterialColorVars.Error.value())
            .setVariable(ButtonVars.BackgroundHoverColor, MaterialColorVars.OnError.shifted(colorMode.opposite, 0.5f))
            .setVariable(ButtonVars.BackgroundFocusColor, MaterialColorVars.OnError.shifted(colorMode.opposite, 0.5f))
            .setVariable(ButtonVars.BackgroundPressedColor, MaterialColorVars.OnError.shifted(colorMode.opposite, 0.2f))
    }
}

val PrimaryTextButtonStyle = ButtonStyle.addVariant {
    base {
        Modifier
            .borderRadius(ButtonVars.BorderRadius.value())
            .setVariable(ButtonVars.BorderRadius, 999.px)
            .setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
            .setVariable(ButtonVars.Color, MaterialColorVars.Primary.value())
            .setVariable(LinkVars.DefaultColor, MaterialColorVars.Primary.value())
            .setVariable(LinkVars.VisitedColor, MaterialColorVars.Primary.value())
            .setVariable(ButtonVars.BackgroundHoverColor, MaterialColorVars.PrimaryContainer.shifted(colorMode.opposite, 0.5f))
            .setVariable(ButtonVars.BackgroundFocusColor, MaterialColorVars.PrimaryContainer.shifted(colorMode.opposite, 0.5f))
            .setVariable(ButtonVars.BackgroundPressedColor, MaterialColorVars.PrimaryContainer.shifted(colorMode.opposite, 0.2f))
    }
}
